import { render, staticRenderFns } from "./ReportsQuicksight.vue?vue&type=template&id=1a447a37&lang=pug&"
import script from "./ReportsQuicksight.vue?vue&type=script&lang=js&"
export * from "./ReportsQuicksight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports